import { FC, PropsWithChildren, ReactNode, useRef, useState } from 'react';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { IconButton } from '@treams/treams-ui';

type Props = PropsWithChildren<{
	label?: ReactNode;
}>;

const DropdownWrapper = styled(Box)`
	position: relative;
	display: inline-block;
`;

const Dropdown = styled(Box)`
	position: absolute;
	top: 100%;
	left: 0;
	background: white;
	border: 1px solid #ddd;
	border-radius: 8px;
	box-shadow: 0 2px 16px rgba(0, 0, 0, 0.1);
	padding: 4px;
	min-width: auto;
	z-index: 1000;
	display: flex;
	flex-direction: column;
`;

export const InlineToolbarDropdown: FC<Props> = ({ label, children }) => {
	const [open, setOpen] = useState(false);
	const containerRef = useRef<HTMLDivElement>(null);

	const handleMouseDown = (event: React.MouseEvent) => {
		const target = event.target as HTMLElement;

		if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
			return;
		}

		event.preventDefault();
	};

	return (
		<DropdownWrapper
			ref={containerRef}
			onMouseEnter={() => setOpen(true)}
			onMouseLeave={() => setOpen(false)}
		>
			<IconButton type="plain" icon={label} onClick={() => setOpen((v) => !v)} />
			{open && <Dropdown onMouseDown={handleMouseDown}>{children}</Dropdown>}
		</DropdownWrapper>
	);
};
